module.exports = __webpack_public_path__ + "assets/img/3.247ab031.jpg";